"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ts_money_1 = require("ts-money");
var InvoiceItem = /** @class */ (function () {
    function InvoiceItem(json) {
        this.id = json.id;
        this.invoiceID = json.invoiceID;
        this.quantity = json.quantity;
        this.productName = json.productName;
        this.productID = json.productID;
        this.unitPrice = ts_money_1.Money.fromInteger(json.unitAmount, 'MYR');
        this.totalPrice = ts_money_1.Money.fromInteger(json.totalAmount, 'MYR');
        this.discount = ts_money_1.Money.fromInteger(json.discountAmount, ts_money_1.Currencies.MYR);
        this.notes = json.notes;
        if (json.preDiscountAmount != null) {
            this.preDiscount = ts_money_1.Money.fromInteger(json.preDiscountAmount, ts_money_1.Currencies.MYR);
        }
    }
    Object.defineProperty(InvoiceItem.prototype, Symbol.toStringTag, {
        get: function () {
            return 'InvoiceItem';
        },
        enumerable: false,
        configurable: true
    });
    return InvoiceItem;
}());
exports.default = InvoiceItem;
